var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgThreadsinline = function SvgThreadsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.047 1.667c-3.703 0-7.323 2.12-7.323 8.324 0 6.245 3.737 8.342 7.332 8.342 4.189 0 6.502-2.458 6.502-5.288 0-1.328-.635-2.49-1.787-3.267a5.263 5.263 0 0 0-.938-.502c-.081-1.184-.431-2.108-1.047-2.755-.612-.647-1.473-.99-2.487-.99-1.431.003-2.468.439-3.254 1.566 0 0 .93.65 1.213.836.416-.483.745-.904 2.041-.904 1.414 0 1.975 1.137 1.975 1.798-.382-.078-1.12-.12-1.727-.12-1.63.003-3.691.79-3.691 2.968.002 1.524 1.45 2.688 3.132 2.688 2.884 0 3.543-2.161 3.788-3.445.064 0 1.319.715 1.319 2.213 0 2.2-2.152 3.705-5.036 3.705-3.51 0-5.852-2.291-5.852-6.607 0-4.81 2.095-7.072 5.8-7.072 2.243 0 4.688.566 5.855 4.122l1.414-.368c-1.507-4.992-5.519-5.244-7.23-5.244Zm.698 8.53c.65 0 1.051.047 1.588.167-.171 2.23-1.262 2.524-2.32 2.524-.58 0-1.662-.301-1.662-1.215 0-.571.274-1.476 2.394-1.476Z",
    fill: "#fff"
  })));
};

export default SvgThreadsinline;